<div>
    <input matInput [placeholder]="placeholder" (input)="onSearchChange($event.target.value)">
    <mat-autocomplete>
      <ng-container *ngFor="let item of data">
        <mat-option [value]="item" (onSelectionChange)="selectItem(item)">
          <ng-content></ng-content>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
  </div>